import React, { useEffect, useState } from 'react'
import { Box, BoxProps, SxProps, Theme, styled } from '@mui/material'

const BGSection = styled('section')<{ width: number | undefined; height: number | undefined }>(
  ({ theme, width, height }) => ({
    display: 'grid',
    gap: '24px',
    width: '100%',
    '::before': {
      zIndex: -1,
      content: '" "',
      left: `-${width ?? 9999999}px`,
      right: `-${width ?? 9999999}px`,
      top: `-${height ?? 9999999}px`,
      bottom: 0,
      position: 'absolute',
      backgroundColor: theme.colors.primary100,
    },
  }),
)

interface Props extends BoxProps {
  children: React.ReactNode[] | React.ReactNode
  sx?: SxProps<Theme>
}

const Section: React.FC<Props> = ({ sx, children, ...props }) => {
  const [ready, setReady] = useState(false)
  const [windowWidth, setWindowWidth] = useState<number | undefined>()
  const [windowHeight, setWindowHeight] = useState<number | undefined>()

  useEffect(() => {
    setReady(true)
  }, [])

  useEffect(() => {
    if (!ready) return
    setWindowHeight(window.outerHeight)
    setWindowWidth(window.outerWidth)
  }, [ready])
  return (
    <Box display='flex' position='relative' {...props}>
      <BGSection width={windowWidth} height={windowHeight} sx={sx}>
        {children}
      </BGSection>
    </Box>
  )
}
export default Section
